const cards = [
  {
    title: '斗破苍穹',
    desc: '三十年河东三十年河西，莫欺少年穷！萧炎踏上强者之路，最新篇章燃爆全场，每周必追的热血玄幻神作。',
    tag: '热血玄幻',
    status: '连载中',
    update: '周更',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20fantasy%20illustration%20with%20flames%20and%20martial%20arts%20energy%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20dynamic%20composition%2C%20clean%20simple%20background%2C%20flat%20design%20style%2C%20epic%20atmosphere&width=600&height=800&seq=manwa-card-1&orientation=portrait',
  },
  {
    title: '一人之下',
    desc: '国漫天花板级别的都市玄幻作品，异人世界的精彩纷争、道家文化与现代都市的完美融合，每一话都让人欲罢不能。',
    tag: '都市玄幻',
    status: '连载中',
    update: '周更',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20urban%20fantasy%20illustration%20with%20traditional%20Chinese%20elements%2C%20warm%20amber%20and%20coral%20tones%2C%20dynamic%20pose%2C%20clean%20simple%20background%2C%20flat%20design%20style%2C%20artistic%20atmosphere&width=600&height=800&seq=manwa-card-2&orientation=portrait',
  },
  {
    title: '海贼王',
    desc: '路飞与草帽团的终极冒险进入最终章，二十余年的连载传奇，每一话都是历史。全世界销量第一的漫画，追更必备。',
    tag: '冒险热血',
    status: '连载中',
    update: '周更',
    img: 'https://readdy.ai/api/search-image?query=Epic%20adventure%20illustration%20with%20pirate%20theme%20and%20ocean%20waves%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20dynamic%20composition%2C%20clean%20simple%20background%2C%20flat%20design%20style%2C%20heroic%20atmosphere&width=600&height=800&seq=manwa-card-3&orientation=portrait',
  },
  {
    title: '间谍过家家',
    desc: '黄昏一家的爆笑温馨日常，间谍、杀手、超能力者组成的伪装家庭，阿尼亚的可爱表情包出圈无数，双周更必追。',
    tag: '家庭喜剧',
    status: '连载中',
    update: '双周更',
    img: 'https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20illustration%20with%20playful%20vibe%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20cute%20atmosphere%2C%20clean%20simple%20background%2C%20flat%20design%20style%2C%20heartwarming%20feel&width=600&height=800&seq=manwa-card-4&orientation=portrait',
  },
  {
    title: '咒术回战',
    desc: '虎杖悠仁与宿傩的命运纠缠，涉谷事变后的全新篇章。咒术师与咒灵之间的战斗愈发激烈，不定期更新但每话必爆。',
    tag: '热血战斗',
    status: '连载中',
    update: '不定期',
    img: 'https://readdy.ai/api/search-image?query=Dark%20supernatural%20battle%20illustration%20with%20cursed%20energy%20effects%2C%20warm%20coral%20and%20amber%20accents%2C%20dynamic%20action%20pose%2C%20clean%20simple%20background%2C%20flat%20design%20style%2C%20intense%20atmosphere&width=600&height=800&seq=manwa-card-5&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门连载
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            当前最受漫友关注的连载漫画，加入追更列表不错过任何更新
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#cards"
              className="group block rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="w-full aspect-[3/4] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 flex-wrap mb-2">
                  <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">{card.tag}</span>
                  <span className="text-xs text-foreground-400">{card.update}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}